'use es6';

export const LAST_VIEWED_INBOX_V2 = 'LocalSettings:Conversations:hsLastViewedInbox:v2';